// extracted by mini-css-extract-plugin
export default {"contain":"tab_contain__FMtiE","left":"tab_left__J1zD9","right":"tab_right__idi3d","trigger_normal":"tab_trigger_normal__axHEU","trigger_pushed":"tab_trigger_pushed__IeDKR"};